import React from 'react';
import { SelectionComponentProps } from '../../../models/LessonComponent';
import { SingleSelectionEditor } from '../SingleSelectionEditor';
import SingleSelectionView from './SingleSelectionView';
import { useLessonContext } from '../../../models/LessonContext';

export default function SingleSelection(props: SelectionComponentProps) {
  const { mode } = useLessonContext();

  return mode === 'edit' ? (
    <SingleSelectionEditor component={props.component} />
  ) : (
    <SingleSelectionView {...props} />
  );
}
